import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from "react-router";

const UpgradeModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgrade = () => {
    onClose();
    navigate("/admin/profile");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 shadow-lg max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-800">
            Upgrade Required
          </h2>
          <CancelIcon
            onClick={onClose}
            className="cursor-pointer text-gray-500 hover:text-gray-700"
          />
        </div>
        <div className="mb-6">
          <p className="text-gray-700 mb-2">
            This feature is available on the Pro plan.
          </p>
          <p className="text-gray-600">
            Please upgrade to unlock&nbsp;full&nbsp;access.
          </p>
        </div>
        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 transition-colors"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors font-semibold"
            onClick={handleUpgrade}
          >
            Upgrade to Pro
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;

